const scroll_top = (e) => {
  if (!!e) {
    e?.preventDefault()
  }
  window.scrollTo({
    behavior: "smooth",
    top: 0,
  })
}

module.exports = scroll_top
